module.exports = __webpack_public_path__ + "static/media/trash-icon.a182af7c.svg";